<template>
  <div class="twoLevelList">
    <div v-if="this.$store.state.webNavigator=='pc'">
      <div class="twoTlt-list">
        <div class="font20px twoTlt-list-li displayIB"
             :class="active==index?'li-active':''"
             v-for="(item , index) in navList"
             :key="index"
             @click="Cactive(index,item)">{{item.text}}
        </div>
      </div>
    </div>
    <div v-if="this.$store.state.webNavigator=='phone'">
      <div class="phone-TowListBox">
        <div class="phone-TowListBtn"
             :class="active==index?'li-active':''"
             v-for="(item , index) in navList"
             :key="index"
             @click="Cactive(index,item)">
          {{item.text}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {$get, $post, } from '@/others/ajax';
import config from '@/others/interface';

export default {
  name: 'twoLevelList',
  props: {
    twolist: {
      type: Array,
      default: null,
    },
    tltType: {
      type: String,
      default: '2',
    },
    titles: {
      type: String,
      default: '减肥案例',
    },
    act: {
      type: String,
      default: '0',
    },
    classCode: {
      type: String,
      default: null,
    },
    toLeveListPath: {
      type: String,
      default: '/',
    },
  },
  components: {},
  data () {
    return {
      active: this.act,
      navList: null,
    };
  },
  mounted () {
    this.getClass();
  },
  methods: {
    async getClass () {
      if (this.classCode !== null) {
        let res = await $get(config.zmlgw + '/web/getClass', {code: this.classCode, });
        if (res.code == 200) {
          this.navList = res.data;
        }
      } else {
        this.navList = this.twolist;
      }
    },
    Cactive (index, item) {
      this.active = index;
      let helpcode = pinyinUtil.getPinyin(item.text, '', false, false);
      if (this.classCode !== null) {
        if (item.text.indexOf('视频') < -1) {
          this.$router.push({path: '/encyclopeDias/' + item.id + '-' + index + '-1-' + helpcode + '.html', });
        } else {
          this.$router.push({path: '/' + this.toLeveListPath + '/' + item.id + '-' + index + '-1-' + helpcode + '.html', });
        }
      } else {
        if (item.type == '1') {
          this.$router.push({path: '/caseVideo/' + index + '-1-' + helpcode + '.html', });
        } else if (item.type == '2') {
          this.$router.push({path: '/caseSharing/' + index + '-1-' + helpcode + '.html', });
        } else if (item.type == 'about') {
          this.$emit('twoType', index);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
  @media screen and (max-width: 800px) {
    @import url('twoLevelListPhone');
  }

  @media screen and (min-width: 800px) {
    @import url('twoLevelList');
  }
</style>



// WEBPACK FOOTER //
// twoLevelList.vue